import React from 'react';

const footer = () => {
    return(
        <React.Fragment>
            <div >
               
            </div>
        </React.Fragment>
    )
};

export default footer;
